// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_404_beneficiary.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon_404_ticket.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__contentContainer___VHGhD {
  padding-bottom: 40px;
  padding-top: 40px;
}

@media only screen and (max-width: 768px) {

.styles__contentContainer___VHGhD {
    padding-bottom: 20px;
    padding-top: 20px;
}
  }

.styles__body___ezHB_ {
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 40px;
  padding-top: 40px;
}

.styles__body___ezHB_:before {
  content: '';
  display: table;
}

.styles__body___ezHB_:after {
  content: '';
  display: table;
  clear: both;
}

.styles__icon___fxgmY {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: contain;
  height: 100px;
  margin: 0 auto;
  text-align: center;
  width: 126px;
}

.styles__iconAccount___ELgH8,
.styles__iconTicket___sIR8V {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.styles__iconBeneficiary___FY8Mn {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.styles__section___dM14x {
  margin-bottom: 20px;
  padding: 100px;
  position: relative;
  width: 100%;
}

@media only screen and (max-width: 768px) {

.styles__section___dM14x {
    margin-top: 0;
    padding: 80px 40px;
}
  }

.styles__column___filYa {
  width: calc(99.9% * 1/1 - (30px - 30px * 1/1));
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.styles__column___filYa:nth-child(1n) {
  float: left;
  margin-right: 30px;
  clear: none;
}

.styles__column___filYa:last-child {
  margin-right: 0;
}

.styles__column___filYa:nth-child(1n) {
  margin-right: 0;
  float: right;
}

.styles__column___filYa:nth-child(1n + 1) {
  clear: both;
}

.styles__errorTitle___uLc20 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-top: 20px;
  text-align: center;
}

.styles__errorMessage___xN8CA {
  margin-bottom: 60px;
  text-align: center;
}

.styles__actionButton___ECMUC {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  color: white;
  line-height: 30px;
  margin-left: 20px;
  padding: 10px 20px;
  width: auto;
}

.styles__actionButton___ECMUC:hover {
    background-color: rgba(55, 110, 161, 0.9);
  }

.styles__actionButton___ECMUC a {
    color: white;
    -webkit-text-decoration: none;
    text-decoration: none;
  }
`, "",{"version":3,"sources":["webpack://./universal/components/Error/styles.css"],"names":[],"mappings":"AAIA;EAEE,oBAAoB;EACpB,iBAAiB;AAMnB;;AAJE;;AALF;IAMI,oBAAoB;IACpB,iBAAiB;AAErB;EADE;;AAGF;EAEE,aAAwB;EAAxB,mBAAwB;EAExB,oBAAoB;EACpB,iBAAiB;AACnB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;AAGxB;;AANA;EAGE,WAAsB;EAAtB,cAAsB;EAAtB,WAAsB;AAGxB;;AAEA;EACE,oEAAuE;EACvE,wBAAwB;EACxB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,yDAAuD;AAEzD;;AAEA;EACE,yDAA4D;AAE9D;;AAEA;EAEE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,WAAW;AAMb;;AAJE;;AAPF;IAQI,aAAa;IACb,kBAAkB;AAEtB;EADE;;AAGF;EACE,8CAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AANA;EACE,WAAkB;EAAlB,kBAAkB;EAAlB,WAAkB;AAKpB;;AANA;EACE,eAAkB;AAKpB;;AANA;EACE,eAAkB;EAAlB,YAAkB;AAKpB;;AANA;EACE,WAAkB;AAKpB;;AAEA;EACE,mDAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,wDAAkB;EAClB,YAAY;EAEZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AAUb;;AARE;IACE,yCAAyC;EAC3C;;AAEA;IACE,YAAY;IACZ,6BAAqB;IAArB,qBAAqB;EACvB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtBlue, gtRed from colors;\n\n.contentContainer {\n  composes: content-container from helpers;\n  padding-bottom: 40px;\n  padding-top: 40px;\n\n  @media only screen and (max-width: 768px) {\n    padding-bottom: 20px;\n    padding-top: 20px;\n  }\n}\n\n.body {\n  composes: content-container from helpers;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n  padding-bottom: 40px;\n  padding-top: 40px;\n}\n\n.icon {\n  background: url('styles/img/icon_404_beneficiary.png') no-repeat center;\n  background-size: contain;\n  height: 100px;\n  margin: 0 auto;\n  text-align: center;\n  width: 126px;\n}\n\n.iconAccount,\n.iconTicket {\n  background-image: url('styles/img/icon_404_ticket.png');\n  composes: icon;\n}\n\n.iconBeneficiary {\n  background-image: url('styles/img/icon_404_beneficiary.png');\n  composes: icon;\n}\n\n.section {\n  composes: boxWrap from helpers;\n  margin-bottom: 20px;\n  padding: 100px;\n  position: relative;\n  width: 100%;\n\n  @media only screen and (max-width: 768px) {\n    margin-top: 0;\n    padding: 80px 40px;\n  }\n}\n\n.column {\n  lost-column: 1 / 1;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.errorTitle {\n  color: gtRed;\n  margin-top: 20px;\n  text-align: center;\n}\n\n.errorMessage {\n  margin-bottom: 60px;\n  text-align: center;\n}\n\n.actionButton {\n  background: gtBlue;\n  color: white;\n  composes: button from helpers;\n  line-height: 30px;\n  margin-left: 20px;\n  padding: 10px 20px;\n  width: auto;\n\n  &:hover {\n    background-color: rgba(55, 110, 161, 0.9);\n  }\n\n  a {\n    color: white;\n    text-decoration: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"contentContainer": `styles__contentContainer___VHGhD ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"body": `styles__body___ezHB_ ${___CSS_LOADER_ICSS_IMPORT_1___.locals["content-container"]}`,
	"icon": `styles__icon___fxgmY`,
	"iconAccount": `styles__iconAccount___ELgH8 styles__icon___fxgmY`,
	"iconTicket": `styles__iconTicket___sIR8V styles__icon___fxgmY`,
	"iconBeneficiary": `styles__iconBeneficiary___FY8Mn styles__icon___fxgmY`,
	"section": `styles__section___dM14x ${___CSS_LOADER_ICSS_IMPORT_1___.locals["boxWrap"]}`,
	"column": `styles__column___filYa`,
	"errorTitle": `styles__errorTitle___uLc20`,
	"errorMessage": `styles__errorMessage___xN8CA`,
	"actionButton": `styles__actionButton___ECMUC ${___CSS_LOADER_ICSS_IMPORT_1___.locals["button"]}`
};
export default ___CSS_LOADER_EXPORT___;
